import { Link } from 'react-router-dom';
import useBgPages from '../../../hooks/use-bg-pages.hook';
import Aside from '../../../components/layout/asaid.component';
import Header from '../../../components/layout/header.component';
import Footer from '../../../components/layout/footer.component';
import Icon from '../../../components/forms/icon.component';

const campaignsMode: React.FC = () => {
  useBgPages();

  const cardElements = [
    {
      title: 'Estándar',
      description:
        'Carga tu base, programa tu envío, elige el canal que prefieras, escribe tu mensaje o selecciona una plantilla y ¡Envíalo fácilmente!.',
      to: '/sendCampaigns/standard-campaigns',
      image: '/assets/media/illustrations/undraw/s-standar.svg',
      iconBtn: 'ki-send'
    },
    {
      title: 'Fallback',
      description:
        'Elige el canal principal de envío y reintenta automáticamente los mensajes no entregados utilizando otros canales para mejorar la tasa de entrega.',
      to: '/sendCampaigns/fallback-campaigns',
      image: '/assets/media/illustrations/undraw/s-automation.svg',
      iconBtn: 'ki-arrows-loop'
    }
    // {
    //   title: 'Flujo de mensajes',
    //   description:
    //     'Conecta flujos de conversación y respuestas; en el mensaje, los usuarios podrán hacer clic en un enlace o responder para iniciar un flujo de conversación previamente configurado.',
    //   to: '/sendCampaigns/flows-campaigns',
    //   image: '/assets/media/illustrations/undraw/s-flow.svg',
    //   iconBtn: 'ki-click'
    // }
  ];

  return (
    <div className="page d-flex flex-row flex-column-fluid">
      <Aside />
      <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <Header />
        <div
          className="content fs-6 d-flex flex-column flex-column-fluid bg-campaigns"
          id="kt_content"
        >
          <div className="container-xxl">
            <div className="d-flex flex-column justify-content-center align-items-left px-5 p-10">
              <div className="text-left mb-10">
                <Icon icon="ki-medal-star" size="fs-3x" type="primary" />
                <span className="fw-bold left fs-3x ms-2">
                  Modalidades de <span className="text-info">campañas.</span>
                </span>
                <p className="fs-4 text-dark">Elige la modalidad que prefieras para tus envíos.</p>
              </div>
              <div className="row">
                {cardElements.map((cardElement) => (
                  <div
                    key={cardElement.to}
                    className={`col-lg-4 mb-10 animate-fadeInUp animate-delay-${cardElement.to} p-7`}
                  >
                    <Link to={cardElement.to} className="text-decoration-none">
                      <div
                        className="card rounded-4 shadow-sm overflow-hidden h-100 border-0 p-7 card-hover-n cursor-pointer"
                        style={{ minHeight: '250px' }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: '170px' }}
                        >
                          <img
                            src={cardElement.image}
                            className="img-fluid"
                            alt={cardElement.title}
                            style={{ maxHeight: '100%', objectFit: 'contain' }}
                          />
                        </div>
                        <div className="separator separator-dashed text-dark my-5"></div>
                        <div className="card-body d-flex flex-column justify-content-between">
                          <h5 className="card-title mb-0 fw-bolder text-primary fs-1 mb-3">
                            {cardElement.title}
                          </h5>
                          <p className="text-dark fs-5">{cardElement.description}</p>
                          <div className="mt-3">
                            <button
                              className="btn btn-light-info rounded-4 w-100 fw-bolder"
                              type="button"
                            >
                              <Icon icon={cardElement.iconBtn} size="fs-1" /> Crear campaña
                            </button>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default campaignsMode;
